import Image from "apps/website/components/Image.tsx";
import Icon from "$store/components/ui/Icon.tsx";

interface Props {
  image: string;
  name: string;
  groupName: string;
}

export default function MainProduct({ image, name, groupName }: Props) {
  return (
    <div class="py-10 px-5 border border-tw-primary-100 rounded-2xl grid gap-4">
      <span class="text-tw-primary-100 text-sm font-extrabold flex items-center gap-1">
        <Icon
          width={18}
          height={12}
          id="BtgEye"
          stroke-width={3}
        />
        Você está vendo este produto
      </span>

      {image
        ? (
          <Image
            class="w-full"
            src={image}
            alt={name}
            width={200}
            height={200}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
        )
        : (
          <div class="w-full aspect-square rounded-2xl bg-tw-base-100 bg-opacity-50" />
        )}

      <span class="text-tw-neutral-500 leading-5 font-nunito font-bold">
        {groupName} {name}
      </span>
    </div>
  );
}
